<template>
  <AutoCompleteComponent
    v-model="model"
    :item-list="getSearchTaxonomies"
    :item-value="itemValue"
    :loading="getLoadingStatus"
    :tool-tip-text="toolTipText"
    @input="selectedValue"
    @fetch-data="getResults"
  />
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import AutoCompleteComponent from "../UtilComponents/AutoCompleteComponent.vue";

export default {
  name: "Taxonomies",
  components: { AutoCompleteComponent },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["input"],
  data: () => {
    return {
      itemSelected: [],
      itemValue: [],
      toolTipText:
        "Taxonomy terms (a.k.a 'species') relating to a resource. Multiple selections will be joined with OR. Start typing to see Taxonomy terms.",
    };
  },

  computed: {
    ...mapGetters("taxonomiesSearch", [
      "getSearchTaxonomies",
      "getLoadingStatus",
    ]),
    ...mapGetters("advancedSearch", ["getEditDialogStatus"]),

    model: {
      get() {
        return this.itemSelected;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    itemSelected(newValue) {
      this.itemValue = newValue;
    },
    /**
     * Item list for the autocomplete should not be empty
     * It is assigned with selected values when edit field is opened
     */
    getEditDialogStatus: {
      handler(open) {
        if (open) {
          if (this.value && this.value.length) {
            this.$store.commit(
              "taxonomiesSearch/setSearchTaxonomies",
              this.value,
            );
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    //Pre-fill selected values on edit advanced search is clicked and open
    this.itemValue = this.value;
  },
  methods: {
    ...mapActions("taxonomiesSearch", ["fetchSearchTaxonomies"]),

    selectedValue(item) {
      this.itemSelected = item;
    },
    getResults(queryParams) {
      if (queryParams) this.fetchSearchTaxonomies(queryParams);
    },
  },
};
</script>
